/**
 * Mirrors the server-side UmsoknType enum.
 * Values must stay in sync with the C# enum in Coredata.Application.
 */
export enum UmsoknType {
  LifeyrisUmsokn = 0,
  LanaUmsokn = 1,
  SereignaSparnadur = 2,
  OrukuUmsokn = 3,
  UtgreidslaSereign = 4,
  SereignBreyting = 5,
  AfsalSereign = 6,
  UppsognSamningSereign = 7,
  RadstofunIdgjaldsSereign = 8,
  NewLaunaGreidandi = 9,
  TilgreinSereign = 10,
  LoanNamechange = 11,
  Barnalifeyrir = 12,
  Makalifeyrir = 13,
  LanGreidslufrest = 14,
  GognTilTR = 15,
  LanVedflutning = 16,
}

/**
 * Maps the Display-name / JSON-property strings returned by the API
 * to the corresponding numeric UmsoknType value.
 */
export const umsoknTypeFromString: Record<string, UmsoknType> = {
  'Umsókn um ellilífeyrir': UmsoknType.LifeyrisUmsokn,
  'Umsókn um lán': UmsoknType.LanaUmsokn,
  'Umsókn um séreignarsparnað': UmsoknType.SereignaSparnadur,
  'Umsókn um séreignarsparnad': UmsoknType.SereignaSparnadur,
  'Umsókn um örorku': UmsoknType.OrukuUmsokn,
  'Umsókn um útgreiðslu séreignarsparnaðar': UmsoknType.UtgreidslaSereign,
  'Breyting á samningi um séreignarsparnað': UmsoknType.SereignBreyting,
  'Umsókn um afsal arfshluta séreignarsparnaðar': UmsoknType.AfsalSereign,
  'Uppsögn á samningi og flutningur á séreign': UmsoknType.UppsognSamningSereign,
  'Ráðstöfun iðgjalds umfram 12% í séreignardeild(opinber launagreiðandi)': UmsoknType.RadstofunIdgjaldsSereign,
  'Tilkynning um nýjan launagreiðanda': UmsoknType.NewLaunaGreidandi,
  'Umsókn og samningur um tilgreindan séreignarsparnað': UmsoknType.TilgreinSereign,
  'Umsókn um nafnabreytingu á láni': UmsoknType.LoanNamechange,
  'Umsókn um barnalífeyri': UmsoknType.Barnalifeyrir,
  'Umsókn um makalífeyri': UmsoknType.Makalifeyrir,
  'Umsókn um greiðslufrest lána': UmsoknType.LanGreidslufrest,
  'Heimild til að senda gögn til Tryggingastofnunar ríkisins (TR)': UmsoknType.GognTilTR,
  'Umsókn um beiðni um veðflutning': UmsoknType.LanVedflutning,
}

/**
 * Resolve a type value that may be either a numeric string, a display-name
 * string, or an enum-name string into the numeric UmsoknType.
 * Returns `undefined` when the input cannot be mapped.
 */
export function resolveUmsoknType(value: string | number | undefined | null): number | undefined {
  if (value == null) return undefined

  // Already a number
  if (typeof value === 'number') return value

  // Numeric string (e.g. "1")
  const num = Number(value)
  if (!Number.isNaN(num) && String(num) === value.trim()) return num

  // Display-name string (e.g. "Umsókn um ellilífeyrir")
  if (value in umsoknTypeFromString) return umsoknTypeFromString[value]

  // Enum member name (e.g. "LoanNamechange")
  const enumVal = UmsoknType[value as keyof typeof UmsoknType]
  if (typeof enumVal === 'number') return enumVal

  return undefined
}
